import { useQuery } from '@tanstack/react-query'
import { CreatorOnlyNotice } from '@/features/marquee/components/creator-only-notice'
import { MarqueeEventForm } from '@/features/marquee/components/event-form'
import { operatorQueryOptions } from '@/features/marquee/query-options'
import { isMarketManagerAllowed } from '@/features/marquee/utils'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

function MarqueeEventNew() {
	const { t } = useTranslation()
	// Creating an event is creator work (FR51). The "Create new" button is
	// already hidden for a facilitator, so only a URL reaches this screen.
	// Answered before this page mounted: `MarqueeSessionRoute` holds the whole
	// section until the operator is known.
	const { data: operator } = useQuery(operatorQueryOptions())

	if (!isMarketManagerAllowed(operator, 'createEvent')) {
		return (
			<>
				<title>{t('marquee:page_title_new')}</title>
				<CreatorOnlyNotice
					backLabel={t('marquee:creator_only_back_to_events')}
					backTo={routes.MARQUEE_EVENTS.handle.fullPath}
				/>
			</>
		)
	}

	return (
		<>
			<title>{t('marquee:page_title_new')}</title>
			<MarqueeEventForm />
		</>
	)
}

export { MarqueeEventNew }
